<template>
  <div class="container" id="login">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-header">Login to MLB Scores Vue App</div>
          <div class="card-body">
            <form action="#" @submit.prevent="submit">
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right">Email:</label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  name="email"
                  value
                  required
                  autofocus
                  v-model="form.email"
                />
              </div>
              <div class="form-group row">
                <label for="password" class="col-md-4 col-form-label text-md-right">Password:</label>
                <input
                  id="password"
                  type="password"
                  class="form-control"
                  name="password"
                  required
                  v-model="form.password"
                />
              </div>
              <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                  <button type="submit" class="btn btn-primary loginBtn">Login</button>
                </div>
              </div>
            </form>
            <div v-if="error" class="alert alert-danger">Could not verify credentials.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          this.$router.replace({ name: "Scores" });
          console.log(data);
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>
<style>
#login {
  font-size: 24px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
}
.card {
  margin-top: 20vh;
}
.card-body {
  margin-top: 5vh;
}
input {
  margin-left: 2vw;
}
.loginBtn {
  background-color: lightblue;
  width: 10vw;
  height: 2vw;
  margin-top: 5vh;
  border-radius: 3px;
}
.loginBtn:hover {
  background-color: lightcoral;
}
</style>